import { AutobiddersFiltersSchema } from '../schema/AutobiddersFiltersSchema'

export const useDefaultAutobiddersFilters = () => {
  return AutobiddersFiltersSchema.cast({
    tmsNames: [],
    shipperNames: [],
  })
}
